import { render, staticRenderFns } from "./serverdialog.vue?vue&type=template&id=050bcc2a&scoped=true"
import script from "./serverdialog.vue?vue&type=script&lang=js"
export * from "./serverdialog.vue?vue&type=script&lang=js"
import style0 from "./serverdialog.vue?vue&type=style&index=0&id=050bcc2a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050bcc2a",
  null
  
)

export default component.exports